module.exports = __webpack_public_path__ + "media/images/flags/1x1/gnq-fce7c706895f2e199a531529b01dd3d0.svg";